import { render, staticRenderFns } from "./TablePageV2.vue?vue&type=template&id=8b7bce64&scoped=true&"
import script from "./TablePageV2.vue?vue&type=script&lang=js&"
export * from "./TablePageV2.vue?vue&type=script&lang=js&"
import style0 from "./TablePageV2.vue?vue&type=style&index=0&id=8b7bce64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7bce64",
  null
  
)

export default component.exports